import type { Catalog } from '..'

export const admin: Catalog['admin'] = {
  notFound: 'Não encontrado',
  notFoundBody: 'Esta página não existe para esta conta.',
  back: 'Voltar',
  instance: 'Instância',
  canvases: 'Canvases',
  accounts: 'Contas',
  breadcrumb: 'Trilha de navegação',
  home: 'Início',
  admin: 'Admin',
  searchCanvasesPlaceholder: 'Buscar canvases ou donos…',
  searchAccountsPlaceholder: 'Buscar contas…',
  searchCanvases: 'Buscar canvases ou donos',
  searchAccounts: 'Buscar contas',
  title: 'Tudo nesta instância',
  accountCount: { one: '{count} conta', other: '{count} contas' },
  canvasCount: { one: '{count} canvas', other: '{count} canvases' },
  frameCount: { one: '{count} frame', other: '{count} frames' },
  canvasesTab: 'Canvases · {count}',
  accountsTab: 'Contas · {count}',
  showingRecent: 'Mostrando os {shown} atualizados mais recentemente de {total}',
  linkAccessView: 'Qualquer pessoa com o link pode ver este canvas',
  linkAccessComment: 'Qualquer pessoa com o link pode comentar neste canvas',
  linkAccessEdit: 'Qualquer pessoa com o link pode editar este canvas',
  linkView: 'link: ver',
  linkComment: 'link: comentar',
  linkEdit: 'link: editar',
  unclaimed: 'sem dono',
  invited: '{count} convidados',
  viewAsName: 'Ver como {name}',
  roleAdmin: 'admin',
  banned: 'banido',
  joined: 'entrou {time}',
  viewAs: 'Ver como',
  unban: 'Desbanir',
  ban: 'Banir',
  banTitle: 'Banir {name} ({email})?',
  unbanTitle: 'Desbanir {name} ({email})?',
  banDescription: 'A pessoa é desconectada de todos os lugares e não pode entrar nem usar o MCP até ser desbanida.',
}
